import { ISubstitute } from '../models/CrossPartDetails';
import { IS_INVERTED_PIN, MFR_RECOMMENDED, SOURCE_PART } from '../constants';
import { getSupplierNameCorePart } from './landindPage.util';
import { IProductVariation } from '../models/ProductDetailById';
import { getCompareQueryString } from '../services';
import { getLangSite } from './translation.util';

export const getUnitPrice = (params: any) => {
  const { data }: any = params;
  let priceMapProductvariations: Array<string> = [];
  if (data.productVariations && data.productVariations.length > 0) {
    data.productVariations.forEach((item: any) => {
      const priceBreaks = item.priceBreaks;
      const packageType = item.packageType?.name;

      // check if exists and package type include Digi-Reel
      if (
        packageType &&
        !packageType.includes('Digi-Reel') &&
        priceBreaks &&
        priceBreaks[0] &&
        priceBreaks[0].price &&
        priceBreaks[0].quantity
      ) {
        const price = priceBreaks[0].price.toFixed(
          Math.max(
            5,
            (priceBreaks[0].price.toString().split('.')[1] || []).length
          )
        );
        const quantity = priceBreaks[0].quantity;

        if (price && quantity) {
          const result = `${quantity}: $ ${price} ${packageType}`;
          priceMapProductvariations.push(result);
        }
      }
    });
  }

  return priceMapProductvariations;
};

export const getUnitPriceTariff = (params: any) =>{
  const { data }: any = params;
  let priceMapProductvariations: Array<string> = [];
  if (data.productVariations && data.productVariations.length > 0) {
    data.productVariations.forEach((item: any) => {
      const priceBreaksIncludeTariff = item.priceBreaksIncludeTariff;
      const packageType = item.packageType?.name;

      // check if exists and package type include Digi-Reel
      if (
        packageType &&
        !packageType.includes('Digi-Reel') &&
        priceBreaksIncludeTariff &&
        priceBreaksIncludeTariff[0] &&
        priceBreaksIncludeTariff[0].price &&
        priceBreaksIncludeTariff[0].quantity
      ) {
        const price = priceBreaksIncludeTariff[0].price.toFixed(
          Math.max(
            5,
            (priceBreaksIncludeTariff[0].price.toString().split('.')[1] || []).length
          )
        );
        const quantity = priceBreaksIncludeTariff[0].quantity;

        if (price && quantity) {
          const result = `${quantity}: $ ${price} ${packageType}`;
          priceMapProductvariations.push(result);
        }
      }
    });
  }

  return priceMapProductvariations;
}


export const getUnitPriceForSorting = (params: any) => {
  if (params && params.data) {
    const { data }: any = params;
    let price: string = '';
    if (data.productVariations && data.productVariations.length > 0) {
      // Sort by quantity ASC
      data.productVariations.sort((a: any, b: any) => {
        // Check exists
        if (
          a.priceBreaks &&
          a.priceBreaks.length > 0 &&
          a.priceBreaks[0].quantity &&
          b.priceBreaks &&
          b.priceBreaks.length > 0 &&
          b.priceBreaks[0].quantity
        ) {
          return a.priceBreaks[0].quantity > b.priceBreaks[0].quantity ? 1 : -1;
        }
      });

      // Check exists and type is Digi-Reel
      if (
        data.productVariations.length >= 2 &&
        data.productVariations[0].packageType &&
        data.productVariations[0].packageType.name.includes('Digi-Reel')
      ) {
        price =
          data.productVariations[1].priceBreaks &&
          data.productVariations[1].priceBreaks[0].price;
      } else {
        price =
          data.productVariations[0].priceBreaks &&
          data.productVariations[0].priceBreaks[0].price;
      }
    }

    return price;
  }
};

export const getUnitPriceTariffForSorting = (params: any) => {
  if (params && params.data) {
    const { data }: any = params;
    let price: string = '';
    if (data.productVariations && data.productVariations.length > 0) {
      // Sort by quantity ASC
      data.productVariations.sort((a: any, b: any) => {
        // Check exists
        if (
          a.priceBreaksIncludeTariff &&
          a.priceBreaksIncludeTariff.length > 0 &&
          a.priceBreaksIncludeTariff[0].quantity &&
          b.priceBreaksIncludeTariff &&
          b.priceBreaksIncludeTariff.length > 0 &&
          b.priceBreaksIncludeTariff[0].quantity
        ) {
          return a.priceBreaksIncludeTariff[0].quantity > b.priceBreaksIncludeTariff[0].quantity ? 1 : -1;
        }
      });

      // Check exists and type is Digi-Reel
      if (
        data.productVariations.length >= 2 &&
        data.productVariations[0].packageType &&
        data.productVariations[0].packageType.name.includes('Digi-Reel')
      ) {
        price =
          data.productVariations[1].priceBreaksIncludeTariff &&
          data.productVariations[1].priceBreaksIncludeTariff[0]?.price;
      } else {
        price =
          data.productVariations[0].priceBreaksIncludeTariff &&
          data.productVariations[0].priceBreaksIncludeTariff[0]?.price;
      }
    }

    return price;
  }
};

export const getUnitPriceFilter = (params: any) => {
  const part: ISubstitute = params.data;
  let priceFilter: Array<number> = [];

  if (part.productVariations) {
    part.productVariations.forEach((element) => {
      const priceBreaks = element?.priceBreaks;
      const packageType = element.packageType?.name;

      if (!packageType?.includes('Digi-Reel') && priceBreaks) {
        priceFilter.push(element.priceBreaks[0].price);
      }
    });
  }
  return priceFilter;
};

export const getUnitPriceTariffFilter = (params: any) => {
  const part: ISubstitute = params.data;
  let priceTariffFilter: Array<number> = [];

  if (part.productVariations) {
    part.productVariations.forEach((element) => {
      if(element.priceBreaksIncludeTariff && element.priceBreaksIncludeTariff.length > 0){
        const priceBreaks = element?.priceBreaksIncludeTariff;
        const packageType = element.packageType?.name;
  
        if (!packageType?.includes('Digi-Reel') && priceBreaks) {
          priceTariffFilter.push(element.priceBreaksIncludeTariff[0].price);
        }
      }
    });
  }
  return priceTariffFilter.length > 0 ? priceTariffFilter : null;
};

export const getDgkProductNumber = (params: any) => {
  const part: ISubstitute = params.data;
  let digiKeyProductNumber: Array<string> = [];
  // check exists
  if (part.productVariations && part.productVariations.length > 0) {
    part.productVariations.forEach((element) => {
      digiKeyProductNumber.push(element.digiKeyProductNumber);
    });
  }
  return digiKeyProductNumber;
};

export const getDgkProductNumberFilter = (params: any) => {
  const part: ISubstitute = params.data;
  let digiKeyProductNumberFilter: Array<string> = [];

  if (part.productVariations) {
    part.productVariations.forEach((element) => {
      digiKeyProductNumberFilter.push(element.digiKeyProductNumber);
    });
  }
  return digiKeyProductNumberFilter;
};

export const getPackageType = (params: any) => {
  const part: ISubstitute = params.data;
  let packageType: Array<string> = [];

  // check exists
  if (part.productVariations && part.productVariations.length > 0) {
    part.productVariations &&
      part.productVariations.forEach((item: any) => {
        if (item && item.packageType && item.packageType.name)
          packageType.push(item.packageType.name);
      });
  }

  return packageType;
};

export const getPinName = (params: any, field: any) => {
  const pinRegex = /^pin[1-9]\d*$/g;
  //Pin Name like /pinName/ or pinName#, pinname is simple(only one name, not include many pins in one field)
  const simpleCaseRegex = /^\/[^/#]+\/$|^[^/#][^/#]+#$/g;
  let pinData =  params.data[field];
    if (pinRegex.test(field) && pinData !== undefined){
      if(simpleCaseRegex.test(pinData) ){
        if (pinData.endsWith('#')){
         return stringSolveForCaseValueSharp(pinData);
        }
        return stringSolveForCaseSlashValueSlash(pinData);
      }
      else {
        pinData = stringSolveForCaseValueSlashValue(pinData);
        pinData= stringSolveForCaseTripleSlash(pinData);
        pinData= stringSolveForCaseSlashValueSlash(pinData);
        pinData= stringSolveForCaseValueSlashValue(pinData);
        pinData= stringSolveForCaseValueSharp(pinData);
        return pinData;
      }
    }
  return pinData
}

//String solving for case just remain value+sharp after replace all slash.
export const stringSolveForCaseValueSharp = (originalPinName: any) => {
  const valueSharpRegex = /([^,]+)#(,|$)/g
  let correctPinName = originalPinName.replace(valueSharpRegex, `${IS_INVERTED_PIN}$1$2`); 
  return correctPinName;
} 
//String solving for case continuous 3slash, it means slash's role is like a Comma("dau phay" in Vietnamese) to seperate 2 pin
export const stringSolveForCaseTripleSlash = (originalPinName: any) => {
  const tripleslashRegex = /\/\/\//g;
  let correctPinName = originalPinName.replace(tripleslashRegex, "/,/"); 
  return correctPinName;
}

//String solving for case slash value slash in a complicated pin name, such as PTA 5, IRQ, TCLK//HFJF/,/RESET/ will be changed to PTA 5, IRQ, TCLK/not(HFJF),not(RESET)
export const stringSolveForCaseSlashValueSlash = (originalPinName: any) => {
  const slashValueSlashRegex = /\/([^/,]+)\//g;
  let correctPinName = originalPinName.replace(slashValueSlashRegex, `${IS_INVERTED_PIN}$1`); 
  return correctPinName;
}

//String solving for case a slash between 2 value, it means slash's role is like a Comma("dau phay" in Vietnamese) to seperate 2 pin
export const stringSolveForCaseValueSlashValue = (originalPinName: any) => {
    const valueSlashValueRegex = /([^/])\/([^/])/g;
    let correctPinName = originalPinName.replace(valueSlashValueRegex, "$1,$2"); 
    return correctPinName;
}

export const getSupplierName = (params: any) => {
  const productVariations: IProductVariation[] = params.data.productVariations;
  let dataSupplierName;
  if (productVariations && productVariations.length > 0)
    dataSupplierName = getSupplierNameCorePart(productVariations);
  else dataSupplierName = params.data.vendor?.value;

  return dataSupplierName;
};

export const getQuantityAvaiable = (params: any) => {
  const part: any = params.data;
  let quantityAvaiable: string;
  let imediateQuantity = 0;
  let marketPlaceQuantity = 0;

  if (part.productVariations && part.productVariations.length > 0) {
    //Count quantity for each vendor
    part.productVariations.forEach(function (item: any) {
      if (item.isMarketPlace) {
        marketPlaceQuantity += item.quantityAvailable;
      } else {
        imediateQuantity += item.quantityAvailable;
      }
    });

    //Check if exist isMarketplace in packet
    const foundMarketPlace = part.productVariations.find((obj: any) => {
      return obj.isMarketPlace;
    });

    //Check if exist IsMarketplace(factory or immediate) in packet
    const foundNotMarketPlace = part.productVariations.find((obj: any) => {
      return obj.isMarketPlace !== true;
    });

    const manufacturerPublicQuantity =
      part.manufacturerPublicQuantity !== 0 && part.manufacturerPublicQuantity;

    if (part.isMarketPlace === undefined) {
      if (foundMarketPlace) {
        //In this case, we just have Marketplace in packet, so will only display marketplace quantity
        if (!foundNotMarketPlace) {
          quantityAvaiable = `${marketPlaceQuantity} - Marketplace`;
        } else {
          // Have both Marketplace and not marketplace in packet, so will display both immediate & marketplace quantity
          if (manufacturerPublicQuantity)
            quantityAvaiable = `${imediateQuantity} - Immediate \n  ${manufacturerPublicQuantity} - Factory \n ${marketPlaceQuantity} - Marketplace`;
          else
            quantityAvaiable = `${imediateQuantity} - Immediate \n ${marketPlaceQuantity} - Marketplace`;
        }
      } else {
        //Don't have Marketplace in packet, so won't display marketplace quantity
        if (manufacturerPublicQuantity)
          quantityAvaiable = `${imediateQuantity} - Immediate \n  ${manufacturerPublicQuantity} - Factory`;
        else quantityAvaiable = `${imediateQuantity} - Immediate`;
      }
    }

    // It means cross, keep it display like normal
    if (part.isMarketPlace) {
      quantityAvaiable = `${part.productVariations[0].quantityAvailable} - Marketplace`;
    } else {
      const quantityAvailableValue = part.quantityAvailable;

      if (manufacturerPublicQuantity)
        quantityAvaiable = `${quantityAvailableValue} - Immediate \n ${manufacturerPublicQuantity}- Factory`;
      else quantityAvaiable = `${quantityAvailableValue} - Immediate`;
    }

    return quantityAvaiable;
  }
};

export const getCrossType = (params: any) => {
  const part: ISubstitute = params.data;
  let crossType: string;

  // check exists and is Recommended
  if (part.crossType && part.crossType.type && part.crossType.crossName) {
    if (
      part.crossType.type === MFR_RECOMMENDED &&
      part.pcnMedia &&
      part.pcnMedia.url
    )
      crossType = `${part.crossType.crossName} - ${part.pcnMedia.url}`;
    else
      crossType =
        part.crossType.crossName === SOURCE_PART
          ? ''
          : part.crossType.crossName;

    return crossType;
  }
};

export const getQuantityAvaiableFilter = (params: any) => {
  if (params && params.data) return params.data.quantityAvailable;
};

export const comparatorValuesCallback = (
  nodeA: any,
  nodeB: any,
  getParams: (node: any) => void
) => {
  const valueA = getParams(nodeA);
  const valueB = getParams(nodeB);
  if (valueA === valueB) return 0;
  return valueA > valueB ? 1 : -1;
};

export const useGetColumnDefs = (IsLoggedIn?: boolean) => [
  {
    field: 'primaryPhotoUrl',
    headerName: 'Image',
    translateKey: 'image-of-part',
    suppressColumnsToolPanel: true,
    hide: true,
    isNotNeedToAddClassRule: true
  },
  {
    field: 'manufacturerProductNumber',
    headerName: 'Mfr Part #',
    cellRenderer: 'PartNumberCellRenderer',
    minWidth: 387,
    checkboxSelection: true,
    suppressSizeToFit: false,
    filter: true,
    sortable: true,
    translateKey: 'mrf-part',
    parameterId: 1111,
    isNotNeedToAddClassRule: true,
    cellClass: 'stringType',
    headerComponentParams: { menuIcon: 'fa-external-link-alt' },
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'supplier',
    headerName: 'Supplier',
    translateKey: 'supplier',
    valueGetter: (params: any) => getSupplierName(params),
    suppressColumnsToolPanel: true,
    hide: true,
    isNotNeedToAddClassRule: true,
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'catalogDescription',
    headerName: 'Catalog Description',
    translateKey: 'catalog-description',
    suppressColumnsToolPanel: true,
    hide: true,
    isNotNeedToAddClassRule: true,
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'crossType.crossName',
    cellRenderer: 'crossTypeCellRenderer',
    headerName: 'Match Type',
    minWidth: 100,
    width: 100,
    suppressSizeToFit: false,
    filter: true,
    sortable: true,
    translateKey: 'match-type',
    isNotNeedToAddClassRule: true,
    valueGetter: (params: any) => getCrossType(params),
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'unitPrice',
    cellRenderer: 'unitPriceCellRenderer',
    headerName: 'Unit Price',
    minWidth: 115,
    width: 115,
    valueGetter: (params: any) => getUnitPrice(params),
    filterValueGetter: (params: any) => getUnitPriceFilter(params),
    comparator: (_: any, __: any, nodeA: any, nodeB: any) =>
      comparatorValuesCallback(nodeA, nodeB, getUnitPriceForSorting),
    filter: true,
    sortable: true,
    translateKey: 'unit-price',
    isNotNeedToAddClassRule: true,
    cellClass: 'multiline',
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'priceBreaksIncludeTariff',
    cellRenderer: 'unitPriceTariffCellRenderer',
    headerName: 'Unit Price Incl. Tariff',
    tooltipField: 'extended-cost-including-tariff-fee',
    minWidth: 155,
    width: 155,
    valueGetter: (params: any) => getUnitPriceTariff(params),
    filterValueGetter: (params: any) => getUnitPriceTariffFilter(params),
    comparator: (_: any, __: any, nodeA: any, nodeB: any) =>
      comparatorValuesCallback(nodeA, nodeB, getUnitPriceTariffForSorting),
    filter: IsLoggedIn,
    sortable: IsLoggedIn,
    suppressMenu: !IsLoggedIn,
    translateKey: 'unit-price-tariff',
    isNotNeedToAddClassRule: true,
    cellClass: 'multiline',
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'quantityAvailable',
    cellRenderer: 'quantityAvailableCellRenderer',
    headerName: 'Quantity Available',
    minWidth: 110,
    width: 110,
    filter: true,
    sortable: true,
    translateKey: 'quantity-available',
    isNotNeedToAddClassRule: true,
    cellClass: 'multiline',
    valueGetter: (params: any) => getQuantityAvaiable(params),
    filterValueGetter: (params: any) => getQuantityAvaiableFilter(params),
    comparator: (_: any, __: any, nodeA: any, nodeB: any) =>
      comparatorValuesCallback(nodeA, nodeB, getQuantityAvaiableFilter),
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'digikeyPartNumber',
    cellRenderer: 'dkPartNumberCellRenderer',
    headerName: 'Digikey Part Number',
    minWidth: 215,
    width: 215,
    valueGetter: (params: any) => getDgkProductNumber(params),
    filterValueGetter: (params: any) => getDgkProductNumberFilter(params),
    filter: true,
    sortable: true,
    translateKey: 'digikey-partnumber',
    isNotNeedToAddClassRule: true,
    cellClass: 'multiline',
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'packageTypeCellRenderer',
    cellRenderer: 'packageTypeCellRenderer',
    headerName: 'Package Type',
    minWidth: 110,
    width: 110,
    valueGetter: (params: any) => getPackageType(params),
    filter: true,
    sortable: true,
    translateKey: 'package-type',
    isNotNeedToAddClassRule: true,
    cellClass: 'multiline',
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'seriesName',
    headerName: 'Series',
    minWidth: 115,
    width: 115,
    filter: true,
    sortable: true,
    translateKey: 'series',
    isNotNeedToAddClassRule: true,
    cellClassRules: {
      'source-part-excel': (params: any) => {
        return params.data.crossType.type === SOURCE_PART;
      }
    }
  },
  {
    field: 'rohsStatus',
    headerName: 'RoHS Compliant',
    translateKey: 'robstatus',
    suppressColumnsToolPanel: true,
    hide: true,
    isNotNeedToAddClassRule: true
  },
  {
    field: 'primaryDatasheetUrl',
    headerName: 'Datasheet',
    translateKey: 'datasheet',
    suppressColumnsToolPanel: true,
    hide: true,
    isNotNeedToAddClassRule: true
  }
];

export const updateColDefs = (list: any, updated: any) => {
  if (list) {
    const index = list.findIndex(
      (item: any) => item.parameterId === updated[0].parameterId
    );
    return [
      ...list.slice(0, index),
      { ...list[index], ...updated[0] },
      ...list.slice(index + 1)
    ];
  }
};

export const updateColDefsUniqueByFieldName = (list: any, updated: any, fieldName:string) => {
  if (list) {
    const index = list.findIndex(
      (item: any) => item.field === fieldName
    );
    return [
      ...list.slice(0, index),
      { ...list[index], ...updated[0] },
      ...list.slice(index + 1)
    ];
  }
};

//this will update all coldef and pass colfield name into their own cell renderer
export const updateAllColDefs = (colDefs:any, updated: any, exceptColDef?:any) =>{
  let newColDefs = colDefs.map((iCol: any)=>{
    if(exceptColDef.includes(iCol.field)){
      let colDef = exceptColDef.find((col:any)=>{
        return col.field === iCol.field
      })
      return {...iCol,...colDef}
    }
    const optionConfigCol = [{
      cellRendererParams:{col:iCol.field,allColumns:colDefs}
    }]
    updated[0] = {...updated[0],...optionConfigCol[0]}
    return {...iCol,...updated[0]}
  })
  return newColDefs
}

export const redirectToComparePage = async (
  productIds: number[],
  returnUrl: string
) => {
  const langSiteObj = getLangSite('en');
  const queryString = new URLSearchParams(new URL(returnUrl).search).get('s');
  const formattedReturnUrl =  `${window.location.origin}/${langSiteObj.lang}/cross-reference?s=${queryString}`
  const compareString = await getCompareQueryString(productIds, formattedReturnUrl);
  const comparePageUrl = `${window.location.origin}/${langSiteObj.lang}/compare?s=${compareString}`;
  window.location.href = comparePageUrl;
};

